module.exports = __webpack_public_path__ + "static/media/appstore-6b.21e6f713.png";